// ISO 4217 also defines testing, settlement, precious-metal, and unit-of-account
// codes that are not appropriate as a workspace's reporting currency.
export const NON_REPORTING_CURRENCY_CODES = new Set([
    'BOV',
    'CHE',
    'CHW',
    'CLF',
    'COU',
    'MXV',
    'USN',
    'UYI',
    'UYW',
    'XAG',
    'XAU',
    'XBA',
    'XBB',
    'XBC',
    'XBD',
    'XDR',
    'XPD',
    'XPT',
    'XSU',
    'XTS',
    'XUA',
    'XXX',
]);

export const isSelectableReportingCurrency = (currencyCode: string) =>
    !NON_REPORTING_CURRENCY_CODES.has(currencyCode);
